export enum HublerPoolEntranceStatus {
  UNELIGIBLE = 'UNELIGIBLE',
  DECLINED_BY_HUBLER = 'DECLINED_BY_HUBLER',
  DECLINED_BY_OPS = 'DECLINED_BY_OPS',
  NEW = 'NEW',
  PENDING_REVIEW = 'PENDING_REVIEW',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  INCOMPLETE = 'INCOMPLETE',
  EXPRESS_APPLICATION = 'EXPRESS_APPLICATION',
}
